import { Props } from '../../../const'
import { 
  Back,
} from "./style";

export default (props: any) => {
  return (
    <Back>
      {props.children}
    </Back>
  )
}
